import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {AddExerciseToWorkoutInput} from '../ports/workout.repository';
import {ExerciseIdValidator} from './exercise-id.validator';
import {WorkoutIdValidator} from './workout-id.validator';

export class AddExerciseToWorkoutDataValidator
  implements Validator<AddExerciseToWorkoutInput>
{
  private static readonly workoutId = new WorkoutIdValidator();
  private static readonly exerciseId = new ExerciseIdValidator();

  readonly standardSchema = z.strictObject({
    workoutId: AddExerciseToWorkoutDataValidator.workoutId.standardSchema,
    exerciseId: AddExerciseToWorkoutDataValidator.exerciseId.standardSchema,
    restSeconds: z.number().int().min(0).max(3600).nullable().optional(),
    targetSets: z.number().int().min(0).max(50).nullable().optional(),
    targetReps: z.number().int().min(1).max(500).nullable().optional(),
    targetWeightKg: z.number().min(0).max(2000).nullable().optional(),
    groupId: z.string().trim().min(1).max(64).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
  });

  validate(value: unknown): Result<AddExerciseToWorkoutInput, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid add exercise to workout data.',
        ),
      );
    }
    return ok(parsed.data);
  }
}
